export default "/images/7490f56cec50890460ce74129894d847.avif";